import React from 'react';
import PropTypes from 'prop-types';

export const IconTrue = ({ className }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle r="8.57143" transform="matrix(-1 0 0 1 8.99888 8.99996)" fill="#27AE60" />
    <g clipPath="url(#icon-true-1)">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.8912 7.25394C14.226 6.91921 14.226 6.3765 13.8912 6.04176C13.5565 5.70703 13.0138 5.70703 12.6791 6.04176L8.14222 10.5786L5.74841 8.18464C5.41369 7.84989 4.87098 7.84987 4.53623 8.1846C4.20148 8.51932 4.20146 9.06203 4.53619 9.39678L7.53619 12.397C7.87091 12.7317 8.41362 12.7318 8.74837 12.397C8.75217 12.3932 8.75593 12.3894 8.75965 12.3855L13.8912 7.25394Z" fill="white" />
    </g>
    <defs>
      <clipPath id="icon-true-1">
        <rect width="10.2857" height="10.2857" fill="white" transform="translate(3.85547 3.85706)" />
      </clipPath>
    </defs>
  </svg>
);

IconTrue.propTypes = {
  className: PropTypes.string
};

IconTrue.defaultProps = {
  className: ''
};
